import React, { useState, useContext } from 'react';
import { useEffect } from 'react';
import SiteSetting from '../../Context/SiteSetting';
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import './Event.scss';
import NumberBlock from '../../Components/NumberBlock/NumberBlock'
import {Input} from '../../Components/Input'
import { useApi } from '../../Hooks/useApi';
import ReactGA from "react-ga4";
import { GetAvailableLanguage } from '../../Utils/Helper';

const Event = (props) => {
  const { register, handleSubmit, setValue, getValues, watch, formState: { errors } } = useForm();
  const { t, i18n } = useTranslation();
  const api = useApi();

  const context = useContext(SiteSetting);
  const { eventID } = useParams();
  const [event, setEvent] = useState(null);
  const [fields, setFields] = useState(null);
  const [total, setTotal] = useState(0);
  const [coupon, setCoupon] = useState(null);

  useEffect(()=>{
    if(context.setting && eventID) {
      const tmp = context.setting.events.filter(item=>item.id === Number(eventID))[0];
      if(tmp) {
        setEvent(tmp);
        ReactGA.event({category: "Event", action: "Open Event", label: tmp.name})
        if(tmp.fields) {
          setFields(tmp.fields[0].attributes);
        }
      } else {
        api.getEvent(context.setting.slug, eventID).then(callback=>{
          if(callback.data) {
            setEvent(callback.data);
            ReactGA.event({category: "Event", action: "Open Event", label: callback.data.name})
            if(callback.data.fields) {
              setFields(callback.data.fields[0].attributes);
            }    
          } else {
            window.location.href = `/${context.setting.slug}`;
          }
        })
      }
    }
  },[])

  const updateTotal = () => {
    const values = watch('ticket');
    const donation = watch('donation');
  
    if (values) {
      const tmpTotal = Object.entries(values).reduce((acc, [key, value]) => {
        if (Number(value) > 0) {
          const ticket = event.days.flatMap(day => day.tickets).find(ticket => ticket.id === key);
          return acc + ticket.cost * Number(value);
        }
        return acc;
      }, 0);

      let total = tmpTotal + (donation ? Number(donation) : 0);


      if(coupon) {
        if(coupon?.type === 1) {
          console.log(coupon?.value);
          total = total - coupon?.value
        }
        if(coupon?.type === 2) {
          console.log(coupon?.percent_off);
          total = total - (total * coupon?.percent_off / 100);
        }
        if(total < 0) total = 0;
      }

      setTotal(total);
    }
  };
  

  useEffect(()=>{
    updateTotal();
  },[watch()])


  const handleForm = (data) => {
    data.account = context.setting.id;
    data.event = eventID;
    data.total = total;
    data.lang = i18n.language;
    if(!data.payment_method) {
      data.payment_method = 2;
    }


    if(total > 0) {
      api.register(data).then(callback=>{
        ReactGA.event({category: "Booking", action: "Booked", value: data.total, label: event.name})
        if(Number(data.payment_method) === 1) {
          window.location.href = `/${context.setting.slug}/${callback.data.url}`;
        } else {
          window.location.href = callback.data.url;
        }
      })
    }
  }

  const checkEmailCoupon = (e) => {
    const email = getValues('email');
    if(email) {
      api.checkEmailCoupon(context.setting.slug, eventID, email).then(callback=>{
          if(callback.data) {
              setCoupon(callback?.data?.coupon)
              updateTotal();
          }
        }
      )
    }
  }

  return (<>
    {event &&
      <>
        <div className="box event">
          {props?.type !== 'embed' && <Link className='back' to={`/${context.setting.slug}`}>{i18n.language === 'en' ? '←' : '→'} {t('Back')}</Link>}
          {GetAvailableLanguage(event.name, i18n)}
          <div className='title'>{event.name[i18n.language]} <span>({event.datetime})</span></div>
          <div className='location'><strong>{t('Location')}:</strong> {event.location[i18n.language]}</div>
          <div className='content' dangerouslySetInnerHTML={{__html: event.content[i18n.language].replace(/(<p data-f-id="pbf">).*(<\/p>)/, '')}} />
          <form onSubmit={handleSubmit(handleForm)} noValidate>
            <div className='tickets'>

            {event.days && event.days.map((item,i) => {
              return (
                <div className='title-wrapper' key={i}>
                  <p className='title'>{item?.title ? item.title[i18n.language] : null}</p>
                  <p className='subtitle'>{item?.sub_title ? item.sub_title[i18n.language] : null}</p>
                  {(item?.max_spots > 0 && item.available_tickets > 0) ? <p className='max_spots'>{item.available_tickets} {t('places left')}</p> : ''}

                  {((item.status && item.max_spots === null) || (item.status && item.max_spots > 0 && item.available_tickets > 0)) ?
                    item?.tickets && item.tickets.map((ticket,inx) => (
                        <div className='ticket-wrapper' key={inx}>
                          <div className='ticket-amount'>
                            <NumberBlock defaultValue={0} register={register} setFormValue={setValue} name={'ticket['+ticket.id+']'} />
                          </div>
                          <div className='ticket-name'>
                            <strong>{ticket?.name[i18n.language]} <span>{context.setting.currency}{ticket.cost}</span></strong><br />
                            <small>{(ticket?.note && ticket?.note[i18n.language]) && ticket.note[i18n.language]}</small>
                          </div>
                        </div>
                    )) : <p className='no_spots'>{t('No spots available')}</p>}

                </div>)
            })}

            </div>
            <div className='form'>
              {fields && Object.keys(fields).map((key,i)=>{
                if(key === 'donation') {return;}
                const value = fields[key];
                const required = value.required===true ? '*' : '';
                // const Pattern = (key === 'email') ? { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: t('invalid_email_address') } : {};
                return value.display &&
                    <><Input
                      key={i}
                      name={key}
                      type={key === 'email' ? key : key === 'phone' ? 'tel' : 'text'}
                      register = {register(key, {
                      required: value.required,
                      // pattern: Pattern,
                      })}
                      errors={errors}
                      title={t(key)}
                      placeholder={t(key) + required}
                      hidelabel='true'
                    />
                    {/* {key === 'email' && <div onClick={checkEmailCoupon} className='checkEmailButton'><img src="/reload_icon.svg" alt='' /></div>} */}
                    </>
                  })
                }

                {fields.extra_fields && Object.values(fields.extra_fields).map((key,i)=>{
                  const name = key['attributes']['name'];
                  const required = key['attributes']['required']===true ? '*' : '';
                  return key['layout'] &&
                    <Input
                      key={i}
                      name={name}  
                      type={key['layout']}
                      register = {register(`extra_fields[${name}]`, {
                      required: required,
                      })}
                      errors={errors}
                      title={key['attributes']['name']}
                      placeholder={t(name) + required}
                      hidelabel='true'
                    />
                  })}

                <div className=''>
                  {fields.donation.display &&
                    <Input
                      name='donation'
                      type='number'
                      register = {register('donation')}
                      errors={errors}
                      title={t('I would like to donate')}
                      placeholder={`${t('Your donation')} (${context.setting.currency})`}
                      min="0"
                      />
                  }
                </div>

                {context.setting.terms_and_conditions &&
                  <label className={`terms_and_conditions ${(errors && errors['terms_and_conditions']) ? 'error' : ''}`}>
                    <input type='checkbox' {...register('terms_and_conditions', {required: true})} />
                    <span>{t('I have read and agreed to the terms of the')} <Link to={`/${context.setting.slug}/terms-and-conditions`} target="_blank">{t('Terms and Conditions')}*</Link></span>
                  </label>
                }

            </div>
            {event.cash === 1 &&
              <div className='wrapper_payment_method'>
                <div className='title_payment_method'>{t('Payment Method')}</div>
                <div className='payment_method'>
                    <Input
                      name='payment_method'
                      type='radio'
                      register = {register('payment_method')}
                      errors={errors}
                      title={t('Credit Card')}
                      value={2}
                      defaultChecked={true}
                    />
                    <Input
                      name='payment_method'
                      type='radio'
                      register = {register('payment_method')}
                      errors={errors}
                      title={t('Cash')}
                      value={1}
                    />
                </div>
              </div>
            }

            <div className='footer'>
                {coupon && <div className='coupon'>{t('coupon')}: 
                  {coupon.type === 1 && <> {context.setting.currency}{coupon.value} {t('off')}</>}
                  {coupon.type === 2 && <> {coupon.percent_off}% {t('off')}</>}
                </div>}
                <div className='total'>{t('total')}: {context.setting.currency}{total}</div>
                <button type='submit'>{t('continue')}</button>
              </div>
          </form>
        </div>
        <div className='footer'>This system was donated by RomanoGroup LTD. <br />RomanoGroup LTD has no responsibility for the activity of the event or the organization.</div>
      </>
    }
  </>);
};

export default Event;